import { AEMScenes } from '@as-react/common-types';
import { authReducer } from '../../authentication/reducers/AuthReducer';
import authenticationSaga from '../../authentication/sagas/AuthSaga';
import { authFormReducer } from '../../authForm/reducers/AuthFormReducer';
import authFormSaga from '../../authForm/sagas/AuthFormSaga';
import { basketReducer } from '../../basket/reducers/BasketReducer';
import basketSaga from '../../basket/sagas/BasketSagas';
import { compareReducer } from '../../compare/reducers/CompareReducer';
import compareSaga from '../../compare/sagas/CompareSagas';
import deliveryPromiseSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
import productRecentlyViewedSaga from '../../productRecentlyViewed/sagas/ProductRecentlyViewedSaga';
import urlSaga from '../../url/sagas/UrlSagas';
import { wishListReducer } from '../../wishList/reducers/WishListReducer';
import wishListSaga from '../../wishList/sagas/WishListSaga';
const loadProductDetailDynamicModule = () => ({
    id: AEMScenes.PRODUCT_DETAIL_V2,
    reducerMap: {
        authentication: authReducer,
        authForm: authFormReducer,
        basket: basketReducer,
        compare: compareReducer,
        wishList: wishListReducer,
    },
    sagas: [
        authenticationSaga,
        authFormSaga,
        basketSaga,
        compareSaga,
        deliveryPromiseSaga,
        urlSaga,
        wishListSaga,
        productRecentlyViewedSaga,
    ],
});
export default loadProductDetailDynamicModule;
